module.exports = __webpack_public_path__ + "static/img/celoscope-32.1407b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-32.jpg
// module id = vIar
// module chunks = 51